import React, { useEffect, useState } from "react";
import { NavLink } from "react-bootstrap";
import { Link } from "react-router-dom";
import API from "../../config/axios";
import { api_paths } from "../../config/api.paths";
import EventDetailFromHome from "../eventsGallery/EventDetailFromHome";

const LIMIT = 6;

export default function EventGallery() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchGallery = async () => {
    try {
      const response = await API.get(
        `${api_paths.member.EVENTS.EVENT_GALLERY_PAGE.GET_LIST}?page=1&limit=${LIMIT}`
      );

      const data = response.data?.payload?.result?.data || [];
      setEvents(data);
    } catch (err) {
      console.error("Gallery fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGallery();
  }, []);

  return (
    <section className="event-gallery my-5">
      {/* Header */}
      {/* <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="team-title h1 mb-0">Event Gallery</h2>

        <NavLink as={Link} to="/events-gallery" className="view-all-link">
          View All
        </NavLink>
      </div> */}

      <div className="d-flex justify-content-center text-center align-items-center mb-4">
        <div className="d-flex justify-content-center align-items-center flex-column ms-auto home-headers">
          <h2 className="team-title mb-2 h1">Event Gallery</h2>
        </div>
        <NavLink
          as={Link}
          to="/events-gallery"
          className="view-all-link ms-auto"
        >
          View All
        </NavLink>
      </div>

      {/* Use SAME event gallery list (eventDetail = false) */}
      <EventDetailFromHome data={events} loading={loading} />
    </section>
  );
}
